const theme = {
  typography: {
    header: '#e60808',
    subHeader: '#26e20a',
    content: '#1012da',
  },
}

export default theme
